import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 32px;
  cursor: pointer;
  display: flex;
  gap: 4px;
  justify-content: flex-end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: flex-start;
  }
  min-width: 180px;
  width: max-content;
  border: 1px solid #004990;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 8px;
  border-radius: 8px;
  color: #004990;
  padding: 0;
  padding: 8px;
`;
export const Label = styled.div`
  margin-left: 0;
  font-weight: 400;
  font-size: 12px;
`;
export const TooltipText = styled.span`
  color: ${({ theme }) => theme.palette.D400};
  margin-bottom: -2px;
  font-size: 14px;
  font-weight: 300;
`;
